import { useEffect } from 'react';

export default function FormActionEnhancer() {
  useEffect(() => {
    const enhanceActions = () => {
      document.querySelectorAll('.app-content .row').forEach((row) => {
        const saveButton = row.querySelector('.btn .pi-check, .btn .pi-save');
        const cancelButton = row.querySelector('.btn .pi-times');

        if (!saveButton || !cancelButton) return;

        const saveButtonElement = saveButton.closest('.btn');
        const cancelButtonElement = cancelButton.closest('.btn');
        const actionsContainer = saveButtonElement.parentElement;

        row.classList.add('form-action-row');
        if (actionsContainer) actionsContainer.classList.add('form-action-buttons');
        saveButtonElement.classList.add('form-save-button');
        cancelButtonElement.classList.add('form-cancel-button');
      });
    };

    enhanceActions();

    const observer = new MutationObserver(enhanceActions);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return null;
}
